export default __webpack_public_path__ + "static/media/sub-banner-num-2.df5e0127.svg";